import { useContext } from 'react'
import { getStorageValue } from 'hooks/data'
import { Context } from './context'

/**
 * Data context validation component.
 */
export const DataEditContextValidation = <T,>({
  children,
}: {
  children: ({ valid, errors }: { valid: boolean; errors: string[] }) => T
}) => {
  const { valid, combinedErrors, errFields } = useContext(Context)

  if (getStorageValue('debug', false)) {
    console.log('Debug validation: valid', valid, 'combinedErrors', combinedErrors, 'errFields', errFields)
  }

  return children({ valid, errors: combinedErrors })
}
